import React from "react";
import { Modal, Button } from "antd";
import { useSearchParams } from "react-router-dom";
import { OrderStepsEnum } from "../../orderTypes";
import { svg } from "../../../../../Assets/svg";

interface Props {
  open: boolean;
  onClose: () => void;
}

const InstallationChecklistRequiredModal: React.FC<Props> = ({
  open,
  onClose,
}) => {
  const [, setSearchParams] = useSearchParams();

  const handleGoToChecklist = () => {
    onClose();
    setSearchParams({
      tab: OrderStepsEnum.INSTALLATION_CHECKLIST,
      mode: "edit",
    });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closeIcon={svg?.closeIcon}
      width={500}
      className="commonModalClass"
    >
      <div className="text-center p-3">
        <h4 className="fw-bold mb-2 text-dark">
          Installation Checklist Required
        </h4>
        <p className="text-muted fs-6 mb-4">
          Installation checklist is required and must be fulfilled before proceeding with Production Planning.
        </p>
        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 gap-sm-3 mt-4">
          <Button
            type="primary"
            className="btn btn-lg btn-primary px-1 px-sm-1 h-auto text-uppercase w-100 w-sm-auto"
            onClick={handleGoToChecklist}
          >
            FILL INSTALLATION CHECKLIST
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InstallationChecklistRequiredModal;
